// components
import { Typography } from '@interstate/components/Typography';
import { Badge } from '@interstate/components/Badge';
import { VehicleImage } from './VehicleImage';
import { Action } from '@interstate/components/Action';

// styles
import {
    VehicleListRowImageContainer,
    VehicleListRowItemContainer,
    VehicleListRowItemNotInStockContent,
    VehicleListRowNotInStockInfoContainer
} from './VehicleListRowItem.interstate.style';

// types
import type { IVehicle } from '@makemydeal/dr-platform-types';
import type { CatalogVehicle } from '../../types';
import { useVehicleTitle } from '../../utils';

export type VehicleListItemProps = {
    vehicle: CatalogVehicle;
    onBuildVehicleClick: (vehicle: IVehicle) => void;
};

export const VehicleListRowItemNotInStock = ({ vehicle, onBuildVehicleClick }: VehicleListItemProps) => {
    const { vin = '' } = vehicle;

    const vehicleListItemTitle = useVehicleTitle(vehicle);

    return (
        <VehicleListRowItemContainer
            data-testid={`vehicle-list-item-${vin}`}
            content={
                <VehicleListRowItemNotInStockContent>
                    <VehicleListRowImageContainer>
                        <VehicleImage vehicle={vehicle} />
                    </VehicleListRowImageContainer>
                    <VehicleListRowNotInStockInfoContainer>
                        <Typography variant="h5" sx={{ marginBottom: '8px' }}>
                            {vehicleListItemTitle}{' '}
                            <Badge variant="info" data-testid="isNotInStockBadge">
                                <Typography variant="body-sm" tag="div">
                                    Not in-stock
                                </Typography>
                            </Badge>
                        </Typography>
                        <Typography variant="body-md" tag="div">
                            {vin}
                        </Typography>
                    </VehicleListRowNotInStockInfoContainer>
                    <Action data-testid="build-vehicle-link" onClick={() => onBuildVehicleClick(vehicle)}>
                        <span style={{ fontSize: '16px' }}>Build Vehicle</span>
                    </Action>
                </VehicleListRowItemNotInStockContent>
            }
        />
    );
};
